'use strict'

function normalizeChoices (choices) {

  if (!Array.isArray(choices)) return []

  const seen = new Set()
  const normalized = []

  for (const choice of choices) {

    const value = String(choice == null ? '' : choice).trim()

    if (!value || seen.has(value)) continue

    seen.add(value)
    normalized.push(value)
  }

  return normalized
}

function hasChoices (choices) {

  return normalizeChoices(choices).length > 0
}

function parseValueList (raw, choices) {

  if (raw == null || raw === '') return []

  if (Array.isArray(raw)) return raw.flatMap(item => parseValueList(item, choices))

  if (typeof raw !== 'string') return [String(raw)]

  const trimmed = raw.trim()

  if (!trimmed) return []

  if (trimmed.startsWith('[')) {

    try {

      const parsed = JSON.parse(trimmed)

      if (Array.isArray(parsed)) return parsed.flatMap(item => parseValueList(item, choices))
    } catch (error) {}
  }

  const allowed = normalizeChoices(choices)

  if (allowed.includes(trimmed)) return [trimmed]

  if (trimmed.includes(',')) return trimmed.split(',').map(part => part.trim()).filter(Boolean)

  return [trimmed]
}

function parseStoredSelection (raw, choices) {

  const allowed = normalizeChoices(choices)
  const seen = new Set()
  const parsed = []

  for (const value of parseValueList(raw, allowed)) {

    if (seen.has(value)) continue

    seen.add(value)
    parsed.push(value)
  }

  if (!allowed.length) return parsed

  const selected = new Set(parsed)

  return allowed.filter(choice => selected.has(choice))
}

function selectionToStored (selected, selectionMode, choices) {

  const ordered = parseStoredSelection(selected, choices)

  if (selectionMode === 'single') return ordered[0] || null

  return JSON.stringify(ordered)
}

module.exports = {
  normalizeChoices,
  hasChoices,
  parseStoredSelection,
  selectionToStored
}
